import { KeyboardBackspace } from '@mui/icons-material';
import { Box, Button, Divider, Paper } from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import React from 'react';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { clearAll } from 'store/SquaresStore/WorkOrderManagement/WorkOrderCreationFormState.slice';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';
import { ProgressStepper } from './components/ProgressStepper';
import { WorkOrderCompletionStep } from './components/WorkOrderCompletionStep';
import WorkOrderCreationStep from './components/WorkOrderCreationStep';
import { WorkOrderActions } from './components/WorkOrderActions';
import type { ServiceView } from 'types/survivalAnalysis.types';
import type { ComponentDetails } from 'types/squares.type';
import { useTranslation } from 'react-i18next';

const FormSection = ({
  components,
  asset,
}: {
  components: ComponentDetails[];
  asset: ServiceView | null;
}) => {
  const activeStep = useAppSelector(
    (store) => store?.sqauresWorkOrderCreationFormReducer?.activeStep
  );
  return (
    <Box
      width={'100%'}
      height={'80%'}
      paddingLeft={3}
      paddingRight={3}
      // border={'1px solid #e5e7eb'}
    >
      {activeStep === 0 ? (
        <WorkOrderCreationStep defaultComponents={components} asset={asset} />
      ) : null}
      {activeStep === 1 ? <WorkOrderCompletionStep /> : null}
    </Box>
  );
};

const WorkOrderCreationFormComponent = ({
  handleBackClick,
  formType,
  formAction,
  components,
  asset,
}: {
  handleBackClick: (value: string) => void;
  formType: 'create' | 'request';
  formAction: 'create' | 'update';
  components: ComponentDetails[];
  asset: ServiceView | null;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      gap={1}
      width={'100%'}
      height={'100%'}
    >
      <Box>
        <Button
          variant="text"
          sx={{
            py: '2px',
            color: palette.buttonLink,
            '&:hover': {
              backgroundColor: `${palette.primary}1A`,
              color: palette.primaryDark,
            },
            '& .MuiButton-startIcon': {
              color: 'inherit',
            },
          }}
          startIcon={<KeyboardBackspace />}
          onClick={() => {
            dispatch(clearAll());
            handleBackClick('creation');
          }}
        >
          {t('cdp_button_back')}
        </Button>
      </Box>

      <Paper
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'column' },
          // gap: 2,
          borderRadius: 2,
          // height: 'calc(100% - 30px)',
        }}
        elevation={1}
      >
        <ProgressStepper />
        <Divider orientation="vertical" flexItem />
        <FormSection components={components} asset={asset} />
        <WorkOrderActions
          formType={formType}
          formAction={formAction}
          handleBackClick={handleBackClick}
        />
      </Paper>
    </Box>
  );
};

export const WorkOrderCreationForm = React.memo(WorkOrderCreationFormComponent);
